import { render, staticRenderFns } from "./MultiPointOutcomeEditorButton.vue?vue&type=template&id=36685753&"
import script from "./MultiPointOutcomeEditorButton.vue?vue&type=script&lang=ts&"
export * from "./MultiPointOutcomeEditorButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports